export const SET_VIDEO_TOKEN = "SET_VIDEO_TOKEN";
export const CONNECT_TO_ROOM = "CONNECT_TO_ROOM";
export const FETCH_ROOM_SUBSCRIPTIONS = "FETCH_ROOM_SUBSCRIPTIONS";

export const setVideoToken = (token) => ({type: SET_VIDEO_TOKEN, payload: token})
export const connectToRoom = (payload) => ({type: CONNECT_TO_ROOM, payload})
export const fetchRoomSubscriptions = () => ({type: FETCH_ROOM_SUBSCRIPTIONS})
